import "./EvaluationSidePanelSummary.less";
import { GuxIcon } from "genesys-spark-components-react";
import { ErrorStatement } from "../features/qualityForm/formEditor/common/ErrorStatement/ErrorStatement";
import PreviewTag from "features/qualityForm/formEditor/sidePanel/PreviewTag";

export interface EvaluationSidePanelSummaryProps {
    iconName: string;
    assistanceIcon: string;
    heading: string;
    preview?: boolean;
    summary: string;
    hasError: boolean;
    errorMessage: string;
}

export function EvaluationSidePanelSummary({
    iconName,
    assistanceIcon,
    heading,
    preview = false,
    summary,
    hasError,
    errorMessage,
}: EvaluationSidePanelSummaryProps) {
    const iconNames = {
        aiScoring: "restricted/custom/sparkles-solid",
        evaluationAssistance: "quote-left",
    };

    return (
        <div className="EvaluationSidePanelSummary">
            <div className="heading">
                <span>{heading}</span>
                {preview && <PreviewTag disabled={false} showTooltip={true} />}
            </div>
            <div className="body">
                <div className="config-summary">
                    <GuxIcon
                        className={iconName}
                        iconName={iconNames[iconName]}
                        screenreader-text={assistanceIcon}
                        decorative={true}
                        data-testid="side-panel-summary-icon"
                    ></GuxIcon>
                    <span>{summary}</span>
                </div>
                {hasError && <ErrorStatement errorMessage={errorMessage} />}
            </div>
        </div>
    );
}
